module.exports = __webpack_public_path__ + "static/media/9.e9a64e60.jpeg";